import React, { useState, useEffect } from 'react';
import api from '../../api/axiosConfig';
import PasswordChangeModal from '../PasswordChangeModal/PasswordChangeModal';
import TwoFactorSetupModal from '../TwoFactorSetupModal/TwoFactorSetupModal';

export default function ConfiguracionCliente({ user, fetchUser, handleLogout, addToast }) {
    const [editMode, setEditMode] = useState(false);
    const [message, setMessage] = useState('');

    const [nombre, setNombre] = useState(user?.nombre || '');
    const [descripcion, setDescripcion] = useState(user?.descripcion || '');

    const [showSetupModal, setShowSetupModal] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);

    const [deactivateStep, setDeactivateStep] = useState('idle');
    const [deactivateCode, setDeactivateCode] = useState('');
    const [deactivateLoading, setDeactivateLoading] = useState(false);
    const [deactivateError, setDeactivateError] = useState('');

    useEffect(() => {
        if (user) {
            setNombre(user.nombre || '');
            setDescripcion(user.descripcion || '');
        }
    }, [user]);

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            await api.put('/update', { nombre });
            setMessage('Usuario actualizado correctamente');
            setEditMode(false);
        if(fetchUser) fetchUser();
        } catch (err) {
            setMessage('Error al actualizar');
        }
    };

    const handleDelete = async () => {
        if (window.confirm('Estas seguro de que quieres eliminar tu cuenta? Esta accion es irreversible.')) {
            try {
                await api.delete('/user/delete');
                if(handleLogout) handleLogout();
            } catch (err) {
                setMessage('Error al eliminar cuenta');
            }
        }
    };

    const handleSetupSuccess = () => {
        setShowSetupModal(false);
        if (addToast) addToast('Doble factor activado correctamente');
        if (fetchUser) fetchUser();
    };

    const handleDesactivar2FA = async (e) => {
        e.preventDefault();
        setDeactivateLoading(true);
        setDeactivateError('');
        try {
            await api.post('/desactivar2FA', { token: deactivateCode });
            setDeactivateStep('idle');
            setDeactivateCode('');
            if (addToast) addToast('Doble factor desactivado correctamente');
            if (fetchUser) fetchUser();
        } catch (err) {
            setDeactivateError(err.response?.data?.error || 'Error al desactivar');
        } finally {
            setDeactivateLoading(false);
        }
    };

    if (!user) return null;

    return (
        <div className="dashboard-content">
            <div className="page-header">
                <h1 className="page-title">Configuracion</h1>
                <p className="page-subtitle">Ajustes de cuenta y preferencias del sistema</p>
            </div>

            {message && (
                <div className={`alert-message ${message.includes('Error') ? 'alert-error' : 'alert-success'}`}>
                    {message}
                </div>
            )}

            <section className="content-section">
                <div className="section-header">
                    <h3><i className="bi bi-person-circle" style={{ marginRight: 8, color: '#2a5a8a' }}></i>Mi Perfil</h3>
                    {!editMode && (
                        <button onClick={() => setEditMode(true)} className="btn btn-outline">
                            <i className="bi bi-pencil"></i> Editar Perfil
                        </button>
                    )}
                </div>

                <div className="section-body">
                    {!editMode ? (
                        <div className="profile-info">
                            <div className="info-row">
                                <span className="info-label">Nombre</span>
                                <span className="info-value">{user.nombre}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Email</span>
                                <span className="info-value">{user.email}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Rol</span>
                                <span className="info-value">
                                    <span style={{ backgroundColor: '#ebf4ff', padding: '4px 10px', borderRadius: '4px', fontSize: '13px', color: '#1a3c5e', fontWeight: 600 }}>
                                        {user.rol}
                                    </span>
                                </span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Descripcion</span>
                                <span className="info-value">
                                    <span style={{ backgroundColor: '#f1f5f9', padding: '4px 10px', borderRadius: '4px', fontSize: '13px', color: '#475569' }}>
                                        {descripcion}
                                    </span>
                                </span>
                            </div>
                            <div className="action-buttons" style={{ marginTop: '32px', paddingTop: '16px', borderTop: '1px solid #f1f5f9' }}>
                                <button onClick={handleDelete} className="btn btn-danger">
                                    <i className="bi bi-trash"></i> Borrar Cuenta
                                </button>
                            </div>
                        </div>
                    ) : (
                        <form onSubmit={handleUpdate} style={{ maxWidth: '400px' }}>
                            <div className="form-group-dash">
                                <label>Nombre Completo</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={nombre}
                                    onChange={e => setNombre(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="action-buttons">
                                <button type="submit" className="btn btn-primary">
                                    <i className="bi bi-floppy"></i> Guardar Cambios
                                </button>
                                <button type="button" onClick={() => setEditMode(false)} className="btn btn-outline">
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </section>

            <section className="content-section" style={{ marginTop: '24px' }}>
                <div className="section-header">
                    <h3><i className="bi bi-shield-lock" style={{ marginRight: 8, color: '#2a5a8a' }}></i>Seguridad</h3>
                </div>
                <div className="section-body">
                    <div className="profile-info">
                        <div className="info-row">
                            <span className="info-label">Doble Factor de Autenticacion</span>
                            <span className="info-value">
                                {user.dobleFactorActivado ? (
                                    <span style={{ backgroundColor: '#ecfdf5', padding: '4px 10px', borderRadius: '4px', fontSize: '13px', color: '#059669', fontWeight: 600 }}>
                                        <i className="bi bi-check-circle" style={{ marginRight: 4 }}></i>Activado
                                    </span>
                                ) : (
                                    <span style={{ backgroundColor: '#fef2f2', padding: '4px 10px', borderRadius: '4px', fontSize: '13px', color: '#dc2626', fontWeight: 600 }}>
                                        <i className="bi bi-x-circle" style={{ marginRight: 4 }}></i>Desactivado
                                    </span>
                                )}
                            </span>
                        </div>
                    </div>

                    {deactivateStep === 'idle' && !user.dobleFactorActivado && (
                        <div className="action-buttons" style={{ marginTop: '16px' }}>
                            <button onClick={() => setShowSetupModal(true)} className="btn btn-primary">
                                <i className="bi bi-shield-plus"></i> Activar doble factor
                            </button>
                        </div>
                    )}

                    {deactivateStep === 'idle' && user.dobleFactorActivado ? (
                        <div className="action-buttons" style={{ marginTop: '16px' }}>
                            <button onClick={() => { setDeactivateStep('code'); setDeactivateCode(''); setDeactivateError(''); }} className="btn btn-danger">
                                <i className="bi bi-shield-x"></i> Desactivar doble factor
                            </button>
                        </div>
                    ) : null}

                    {deactivateStep === 'code' && (
                        <div style={{ marginTop: '20px', textAlign: 'center' }}>
                            <p style={{ color: '#475569', fontSize: '14px', marginBottom: '16px' }}>
                                Ingresá el código de 6 dígitos de tu aplicación de autenticación para desactivar
                            </p>

                            {deactivateError && <div style={{ backgroundColor: '#fef2f2', color: '#c0392b', padding: '10px', borderRadius: '8px', marginBottom: '16px', fontSize: '13px', border: '1px solid #fecaca' }}>{deactivateError}</div>}

                            <form onSubmit={handleDesactivar2FA} style={{ maxWidth: '280px', margin: '0 auto' }}>
                                <div className="form-group-dash">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={deactivateCode}
                                        onChange={e => setDeactivateCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                        placeholder="000000"
                                        maxLength={6}
                                        style={{ fontSize: '24px', fontWeight: 700, letterSpacing: '8px', textAlign: 'center' }}
                                        required
                                        disabled={deactivateLoading}
                                    />
                                </div>
                                <div className="action-buttons" style={{ justifyContent: 'center' }}>
                                    <button type="submit" className="btn btn-danger" disabled={deactivateLoading || deactivateCode.length !== 6}>
                                        <i className="bi bi-check-lg"></i> {deactivateLoading ? 'Desactivando...' : 'Confirmar y desactivar'}
                                    </button>
                                    <button type="button" onClick={() => { setDeactivateStep('idle'); setDeactivateCode(''); setDeactivateError(''); }} className="btn btn-outline" disabled={deactivateLoading}>
                                        Cancelar
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </section>

            <section className="content-section" style={{ marginTop: '24px' }}>
                <div className="section-header">
                    <h3><i className="bi bi-key" style={{ marginRight: 8, color: '#2a5a8a' }}></i>Contraseña</h3>
                </div>
                <div className="section-body">
                    <div className="action-buttons" style={{ marginTop: '8px' }}>
                        <button onClick={() => setShowPasswordModal(true)} className="btn btn-outline">
                            <i className="bi bi-pencil"></i> Cambiar contraseña
                        </button>
                    </div>
                </div>
            </section>

            {showSetupModal && (
                <TwoFactorSetupModal
                    onClose={() => setShowSetupModal(false)}
                    onSuccess={handleSetupSuccess}
                />
            )}

            {showPasswordModal && (
                <PasswordChangeModal
                    user={user}
                    onClose={() => setShowPasswordModal(false)}
                    onSuccess={() => {
                        setShowPasswordModal(false);
                        if (addToast) addToast('Contraseña cambiada correctamente');
                    }}
                />
            )}
        </div>
    );
}